export const X_ACCOUNT_LABEL = 'X (Twitter)'
